import React from 'react'

import { ButtonClean, Subsection } from '@fourthwall/components'
import { routing } from '@utils/routing'

export const VideosFields = () => (
  <Subsection title="Videos">
    You can add videos to series by editing them.{' '}
    <ButtonClean label="Visit posts tab" withUnderline to={routing.memberships.posts.self} />
  </Subsection>
)
